

const radio_live = () => {
    const playButton = document.querySelector('.play-button');
    const audio = new Audio('https://paper2020.radioca.st/stream?type=http&nocache=77440');

    playButton.addEventListener('click', function () {
        playButton.classList.toggle('is-playing');

        if (audio.paused) {
            audio.play();
        } else {
            audio.pause();
        }
    });

    audio.addEventListener('play', function () {
        playButton.querySelector('.icon-play').style.display = 'none';
        playButton.querySelector('.pause').style.display = 'inline-block';
    });

    audio.addEventListener('pause', function () {
        playButton.querySelector('.icon-play').style.display = 'inline-block';
        playButton.querySelector('.pause').style.display = 'none';
    });
}

export default radio_live;